import gsap from 'gsap';
import { Icon } from './Icon';
import { GetBy } from '../_app/cuchillo/core/Element';
import EventDispatcher from '../_app/cuchillo/core/EventDispatcher';
import Sidemenu from '../layout/Sidemenu';

export class BurgerIcon extends Icon {
  _isOpen = false;

  constructor(dom) {
    super(dom);

    this._calls.open = () => this._toAsterisk();
    this._calls.close = () => this._toBurger();
    this._calls.hide = () => {};

    EventDispatcher.addEventListener(Sidemenu.ON_SHOW, this._calls.open);
    EventDispatcher.addEventListener(Sidemenu.ON_HIDE, this._calls.close);
  }

  // Hover handled by CSS :hover — no JS needed
  show() {}
  hide() {}

  _toAsterisk() {
    this._isOpen = true;
    this.dom.classList.add('--open');
  }

  _toBurger() {
    this.dom.classList.remove('--open');
    gsap.delayedCall(0.4, () => { this._isOpen = false; });
  }

  dispose() {
    EventDispatcher.removeEventListener(Sidemenu.ON_SHOW, this._calls.open);
    EventDispatcher.removeEventListener(Sidemenu.ON_HIDE, this._calls.close);
    super.dispose();
  }

  resize() {
    super.resize();
  }
}
